export default __webpack_public_path__ + "static/media/RadialBtnChecked.bcd45e2c.svg";